import { initializePaddle, Paddle } from "@paddle/paddle-js";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";

export default function Checkout() {
  // Create a local state to store Paddle instance
  const [paddle, setPaddle] = useState<Paddle>();
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  // Download and initialize Paddle instance from CDN
  useEffect(() => {
    initializePaddle({
      environment: "sandbox",
      token: "test_bfda518ec13124ce67f4cd776df",
    }).then((paddleInstance: Paddle | undefined) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, []);

  // Callback to open a checkout
  const openCheckout = () => {
    paddle?.Checkout.open({
      items: [{ priceId: "pri_01jwe0dnprcwemas2gha0xf0x9", quantity: 1 }],
    });
  };

  return <button onClick={openCheckout}>{t("OpenCheckout")}</button>;
}
